const TeamBasedStudents = () => {
  return (
    <div>
      <h1>Team Based Students</h1>
    </div>
  );
};

export default TeamBasedStudents;
